import React, { FunctionComponent, useState, useEffect } from "react";
import {
  Sidebar,
  AppContainer,
  MainWrapper,
  StatusWrapper,
  useTranslations,
} from "@gf-easy-8/grmnext-foundation";
import Routes from "../routes";

import usePermission from "provider/PermissionProvider";
import { Navs } from "../constant";
import StatusBar from "../components/v2/StatusBar/StatusBar";
import { AssetWrapper } from "../components/v2/AssetWrapper/AssetWrapper";
import UsersIcon from "../components/v2/icons/generated/UsersOutline";
import DashboardIcon from "../components/v2/icons/generated/DashboardViewOutline";
import SearchIcon from "../components/v2/icons/generated/SearchOutline";
import ChipIcon from "../components/v2/icons/generated/ChipOutline";
import KeyIcon from "../components/v2/icons/generated/KeyOutline";
import MoneyIcon from "../components/v2/icons/generated/MoneyOutline";
import ListIcon from "../components/v2/icons/generated/ListOutline";
import SettingsIcon from "../components/v2/icons/generated/SettingsOutline";
import Loader from "../components/Loader";
import SnackbarWrapper from "./SnackbarWrapper";

import ROUTES, { UserManagementPath } from "../routes/paths";

const Layout: FunctionComponent = ({ account, children }: any) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { getTranslation } = useTranslations();
  const { permissionContext } = usePermission();
  const [refreshPermissions] = permissionContext.refresh;
  const { menuPermissions } = permissionContext.permissions;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    refreshPermissions(account.userName).then(() => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <Loader fullpage />;
  }

  const list = [
    {
      icon: SettingsIcon,
      label: getTranslation("MENU:CONFIGURATION"),
      testID: "side_nav_configuration_page",
      link: ROUTES.configuration,
    },
    {
      icon: ChipIcon,
      label: getTranslation("MENU:FIRMWARES"),
      testID: "side_nav_firmwares_page",
      link: ROUTES.firmwares,
    },
    {
      icon: KeyIcon,
      label: getTranslation("MENU:FEATURE_KEYS"),
      testID: "side_nav_feature_keys_page",
      link: ROUTES.featureKeys,
    },
    {
      icon: ListIcon,
      label: getTranslation("MENU:LICENSES"),
      testID: "side_nav_licenses_page",
      link: ROUTES.licenses,
    },
    {
      icon: MoneyIcon,
      label: getTranslation("MENU:VOUCHERS"),
      testID: "side_nav_vouchers_page",
      link: ROUTES.vouchers,
    },
    {
      icon: DashboardIcon,
      label: getTranslation("MENU:VOUCHER_OVERVIEW"),
      testID: "side_nav_voucher_overview_page",
      link: ROUTES.voucherOverview,
    },
    {
      icon: SearchIcon,
      label: getTranslation("MENU:VOUCHER_SEARCH"),
      testID: "side_nav_voucher_search_page",
      link: ROUTES.voucherSearch,
    },
  ];
  type Menu =
    | "Configuration"
    | "Firmwares"
    | "FeatureKeys"
    | "Licenses"
    | "Vouchers"
    | "Entitlements"
    | "VoucherSearch"
    | "Users";
  const filteredPaths = Object.keys(Navs)
    .filter((key) => menuPermissions.includes(key))
    .reduce((obj: string[], key) => {
      obj = [...obj, Navs[key as Menu].path];
      return obj;
    }, []);

  let bottomList: any[] = [];

  if (filteredPaths.includes(UserManagementPath)) {
    bottomList = [
      {
        icon: UsersIcon,
        label: getTranslation("MENU:USER_MANAGEMENT"),
        testID: "side_nav_user_management_page",
        link: ROUTES.userManagement,
      },
      ...bottomList,
    ];
  }
  return (
    <div className="main-container-v2">
      <AppContainer isOpen={isOpen}>
        <Sidebar
          list={list.filter((menu: any) => filteredPaths.includes(menu.link))}
          bottomList={bottomList}
          home={ROUTES.root}
          isOpen={isOpen}
          onToggle={() => setIsOpen(!isOpen)}
        />
        <AssetWrapper></AssetWrapper>
        <MainWrapper data-test-id="main_wrapper">
          <div id="main-content-v2">
            <Routes permissions={menuPermissions} />
          </div>
        </MainWrapper>
        <StatusWrapper>
          <StatusBar />
        </StatusWrapper>
        <div id="modal-root" />
      </AppContainer>
      <SnackbarWrapper />
    </div>
  );
};

export default Layout;
